import { HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface BadgeGroup extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export default function BadgeGroup (props: BadgeGroup) {
  const { className, ...rest } = props

  return (
    <div className={cn(styles.group, className)} {...rest}>
      {props.children}
    </div>
  )
}
